// Customized Map Zoom Controls
function ZoomControl(controlDiv, map) {

  controlDiv.style.padding = '5px';

  // Control Styling
  var controlWrapper = document.createElement('div');
  controlWrapper.style.cursor = 'pointer';
  controlWrapper.style.textAlign = 'center';
  controlWrapper.style.width = '40px';
  controlWrapper.style.height = '90px';
  controlWrapper.style.color = '#ADADAD';
  controlDiv.appendChild(controlWrapper);

  var zoomInButton = document.createElement('div');
  zoomInButton.style.width = '30px';
  zoomInButton.style.height = '30px';
  zoomInButton.style.marginBottom = '5px';
  zoomInButton.style.backgroundColor = '#313131';
  zoomInButton.style.borderStyle = 'solid';
  zoomInButton.style.borderColor = '#5C5C5C';
  zoomInButton.style.borderWidth = '1px';
  zoomInButton.style.borderRadius = '50%';
  zoomInButton.style.fontSize = '20px';
  zoomInButton.style.lineHeight = '1.4em';
  zoomInButton.innerHTML = '&#43;';
  controlWrapper.appendChild(zoomInButton);

  var zoomOutButton = document.createElement('div');
  zoomOutButton.style.width = '30px';
  zoomOutButton.style.height = '30px';
  zoomOutButton.style.backgroundColor = '#313131';
  zoomOutButton.style.borderStyle = 'solid';
  zoomOutButton.style.borderColor = '#5C5C5C';
  zoomOutButton.style.borderWidth = '1px';
  zoomOutButton.style.borderRadius = '50%';
  zoomOutButton.style.fontSize = '26px';
  zoomOutButton.style.lineHeight = '1em';
  zoomOutButton.innerHTML = '&#45;';
  controlWrapper.appendChild(zoomOutButton);

  // Event Listener
  google.maps.event.addDomListener(zoomInButton, 'click', function() {
    map.setZoom(map.getZoom() + 1);
  });

  google.maps.event.addDomListener(zoomOutButton, 'click', function() {
    map.setZoom(map.getZoom() - 1);
  });

}; // zoom controls

function initMap() {

  let map,
      marker,
      markerIcon;
  const mapElement  = document.querySelector('#location__gmap');

  if (mapElement) {
    const lat         = mapElement.dataset.lat * 1;
    const lng         = mapElement.dataset.lng * 1;
    const location    = {lat: lat, lng: lng};
    const mapStyle    = [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 19
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#5c5c5c"
                },
                {
                    "weight": "0.13"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station.airport",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.station.bus",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ];

    map = new google.maps.Map(mapElement, {
      center: location,
      zoom: 15,
      disableDefaultUI: true,
      zoomControl: false,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: true,
      styles: mapStyle,
    }); // map

    markerIcon = new google.maps.MarkerImage('/wp-content/themes/template/res/img/svg/maps_pin.svg',
                 new google.maps.Size(50, 50),
                 new google.maps.Point(0, 0),
                 new google.maps.Point(24, 24));

    marker = new google.maps.Marker({
      position: location,
      map: map,
      icon: markerIcon,
    });

    var zoomControlDiv = document.createElement('div');
    var zoomControl = new ZoomControl(zoomControlDiv, map);
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv);
  }

}; // init map

export default initMap;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Location.js